var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPrefer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#00C8A9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.308 15.428a2.308 2.308 0 0 0-2.154-3.733 2.31 2.31 0 0 0-4.31 0 2.308 2.308 0 0 0-2.15 3.733 2.31 2.31 0 0 0 2.155 3.732 2.31 2.31 0 0 0 4.31 0 2.308 2.308 0 0 0 2.149-3.732h0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.127 19.005v4.35c0 .155-.117.296-.3.362a.65.65 0 0 1-.555-.054L17 22.208l-2.272 1.455a.65.65 0 0 1-.555.054c-.183-.066-.3-.207-.3-.363v-4.349M15 15.428a2 2 0 1 0 4 0 2 2 0 0 0-4 0h0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.391 4.696a3.696 3.696 0 1 0 7.392 0 3.696 3.696 0 0 0-7.392 0zM2 15.783a6.087 6.087 0 0 1 9.377-5.122M6.5 4V2M9.5 4V2M3 4.5h10.5",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5a2.5 2.5 0 0 0 5 0M4.5 11.5V16",
    stroke: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrefer);
export default __webpack_public_path__ + "static/media/iconPrefer.61339cbbfc48c7ece1576fd1fbbd7495.svg";
export { ForwardRef as ReactComponent };